import { useReducer } from 'react';

// A reducer function that increments a counter and wraps around at 1,000,000
const reducer = (value: number) => (value + 1) % 1000000;

/**
 * useForceUpdate
 *
 * Custom React hook that provides a function to force the component to re-render.
 * It uses useReducer with a dummy counter that increments on each call,
 * causing React to trigger a re-render even though no meaningful state changes.
 *
 * Useful in rare situations where you need to imperatively update the component,
 * such as when working with third-party libraries or non-React state.
 *
 * @returns A function that, when called, triggers a re-render of the component.
 */
export function useForceUpdate(): () => void {
    const [, update] = useReducer(reducer, 0);
    return update;
}
